import get from 'lodash/get';
import { COLOR } from '@ordermentum/ui-constants';

export type Colors =
  | 'default'
  | 'red'
  | 'orange'
  | 'gray'
  | 'gray_light'
  | 'grayish'
  | 'gray_charcoal'
  | 'white'
  | 'blue_window'
  | 'error'
  | 'disabled';

export const ICON_SIZES = {
  x3s: '0.8rem',
  x2s: '1rem',
  xs: '18px',
  sm: '20px',
  re: '22px',
  md: '24px',
  lg: '36px',
  ml: '44px',
  xl: '48px',
  x2l: '64px',
};

export const ICON_COLORS = {
  black: COLOR.BLACK,
  red: COLOR.RED_500,
  orange: COLOR.ORANGE,
  gray: COLOR.GRAY_500,
  gray_light: COLOR.GRAY_300,
  storm: COLOR.GRAY_363940,
  grayish: COLOR.GRAY_400,
  gray_charcoal: COLOR.GRAY_800,
  white: COLOR.WHITE,
  default: COLOR.GRAY_400,
  error: COLOR.RED_500,
  disabled: COLOR.GRAY_400,
  green: COLOR.SUCCESS,
  blue_ice: COLOR.BLUE_600,
  warning: COLOR.YELLOW_500,
  blue_window: COLOR.BLUE_500,
  green_mint: COLOR.GREEN_500,
  green_moss: COLOR.GREEN_400,
  pink_light: COLOR.RED_600,
  maroon_light: COLOR.RED_700,
};

export const getSize = (size?: string) =>
  get(ICON_SIZES, `${size}`, ICON_SIZES.md);

export const getColor = (color: string = 'default') =>
  get(ICON_COLORS, `${color}`, ICON_COLORS.default);
